import {
  DictionaryField,
  FieldId,
} from '../../../gk-dynamic-list/services/dictionary/dictionary.model';
import { CommunityGusField } from '../../../services/community-gus-dictionary/community-gus-dictionary.model';
import { CountryDictionaryService } from '../../../services/country-dictionary/country-dictionary.service';
import { DistrictGusField } from '../../../services/district-gus-dictionary/district-gus-dictionary.model';
import {
  FormlyBaseFormConfig,
  FormlyBaseFormExpressions,
  FormlyExtendedControlToOverride,
  FormlyExtendedPropertyToOverride,
} from '../../../services/formly/formly-base-config/formly-base-config.model';

export enum AddressSelectFormControlName {
  Country = 'country',
  Voivodeship = 'voivodeship',
  District = 'district',
  Community = 'community',
  Street = 'street',
  BuildingNumber = 'buildingNumber',
  LocalNumber = 'localNumber',
  Place = 'place',
  PostalCode = 'postalCode',
  PostOffice = 'postOffice',
}

export class AddressSelectFormModel {
  constructor(
    public country: string,
    public voivodeship: string,
    public district: DistrictGusField,
    public community: CommunityGusField,
    public street: string,
    public buildingNumber: string,
    public localNumber: string,
    public place: string,
    public postalCode: DictionaryField | string,
    public postOffice?: string,
  ) {}

  static getEmptyModel(): AddressSelectFormModel {
    return new this(
      undefined,
      undefined,
      {} as DistrictGusField,
      {} as CommunityGusField,
      undefined,
      undefined,
      undefined,
      undefined,
      {} as DictionaryField,
      undefined,
    );
  }
}

export const addressSelectFormModel = AddressSelectFormModel.getEmptyModel();

export type AddressSelectFormExpressions =
  FormlyBaseFormExpressions<AddressSelectFormControlName>;

export class AddressSelectFormControlToOverride extends FormlyExtendedControlToOverride<AddressSelectFormControlName> {
  constructor(
    controlName: AddressSelectFormControlName,
    properties: AddressSelectFormExtendedPropertyToOverride[],
  ) {
    super(controlName, properties);
  }
}
export class AddressSelectFormExtendedPropertyToOverride extends FormlyExtendedPropertyToOverride<AddressSelectFormControlName> {
  constructor(pathToProperty: string[], value: any) {
    super(pathToProperty, value);
  }
}

export class AddressSelectFormConfig extends FormlyBaseFormConfig<AddressSelectFormControlName> {
  constructor(
    fieldsToHide: AddressSelectFormControlName[] = [],
    propertiesToOverride: AddressSelectFormExpressions = {},
    extendedPropertiesToOverride?: AddressSelectFormControlToOverride[],
  ) {
    super(fieldsToHide, propertiesToOverride, extendedPropertiesToOverride);
  }
}

export const isPolandCountrySelected = (countryId: FieldId): boolean => {
  return Number(countryId) === CountryDictionaryService.polandCountryId;
};
